<!-- <div class="py-7 flex justify-end items-center">
	<button class="bg-primary px-3 py-2 rounded text-[12px] text-white" (click)="addNewAccount()">Créer un
		sous-compte</button>
</div> -->

<!-- Loading -->
<div *ngIf="loading" class="flex justify-center items-center py-8">
	<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
	<span class="ml-2 text-gray-600">Chargement des comptes gérés...</span>
</div>

<!-- Tableau des comptes gérés -->
<div *ngIf="!loading" class="mt-5 bg-white rounded-lg border border-gray-200 shadow overflow-hidden">
	<div class="overflow-x-auto">
		<table class="w-full">
			<thead>
				<tr class="bg-gray-50 border-b border-gray-200">
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Prénom</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Nom</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Sexe</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Date de naissance</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Téléphone</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Type de compte</th>
					<!-- <th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Actions</th> -->
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let account of filteredAccounts" class="border-b border-gray-100 hover:bg-gray-50">
					<td class="py-3 px-4 text-sm font-medium text-gray-900">
						{{ account.firstName }}
					</td>
					<td class="py-3 px-4 text-sm font-medium text-gray-900">
						{{ account.lastName }}
					</td>
					<td class="py-3 px-4">
						<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
							[ngClass]="getSexClass(account.sex)">
							{{ getSexText(account.sex) }}
						</span>
					</td>
					<td class="py-3 px-4 text-sm text-gray-600">
						{{ formatDate(account.birthday) }}
					</td>
					<td class="py-3 px-4 text-sm text-gray-600">
						{{ getPrimaryPhone(account.phoneNumbers) }}
					</td>
					<td class="py-3 px-4">
						<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
							[ngClass]="getAccountTypeClass(account.accountType)">
							{{ getAccountTypeText(account.accountType) }}
						</span>
					</td>
					<td class="py-3 px-4">
						<div class="flex items-center space-x-2">
							<button
								class="text-[12px] text-white flex gap-x-1 items-center bg-primary px-3 py-2 rounded-md hover:bg-primary transition-colors cursor-pointer"
								(click)="upgradeToMainAccount(account)">
								<lucide-icon [img]="shieldIcon" [size]="16"></lucide-icon>
								<span>Rendre ce compte autonome</span>
							</button>
						</div>
					</td>
				</tr>

				<!-- Message si aucun compte -->
				<tr *ngIf="filteredAccounts.length === 0">
					<td colspan="7" class="py-8 px-4 text-center text-gray-500">
						<svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
							</path>
						</svg>
						<p class="mt-2">Aucun compte géré trouvé</p>
						<p class="text-sm text-gray-400">Commencez par ajouter un nouveau compte</p>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>